













import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { getTaskGroupConfig, TaskType } from '@/config/task';
import TaskList from './task-list.vue';
import { getTaskOrder, useTaskStore } from '@/store/task';
import { TaskItem } from '@/types/task';

export default defineComponent({
  name: 'TaskGroup',
  props: {
    /** 任务组类型 */
    taskGroupType: {
      type: String as PropType<TaskType>,
      required: true,
    },
  },
  components: {
    TaskList,
  },
  setup(props) {
    const { taskGroupType } = toRefs(props);
    const { getTaskGroupInfo } = useTaskStore();
    /** 当前任务类型下的任务id列表 */
    const taskNameIdList = computed(() => {
      const { taskInfoList } = getTaskGroupInfo(taskGroupType.value);
      return taskInfoList.map(item => item.taskNameId);
    });
    /** 任务组配置 */
    const taskGroupConfig = getTaskGroupConfig(taskGroupType.value);
    /** 是否是特殊任务组(例如限时任务、新手任务) */
    const isSpecialTaskGroup = computed(() => ['limit', 'newUser'].includes(taskGroupType.value));
    /** 任务排序逻辑, 根据任务的权重，从大到小排序 */
    const sortTaskListFunc = (a: TaskItem, b: TaskItem) => getTaskOrder(b) - getTaskOrder(a);
    return {
      sortTaskListFunc,
      taskNameIdList,
      taskGroupConfig,
      isSpecialTaskGroup,
    };
  },
});
